import { Box, IconButton } from '@mui/material'
import { ArrowDownload24Regular, ZoomIn24Regular, ZoomOut24Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import styles from '../AttachmentImageGallery.module.scss'

export function AttachmentImageGalleryHeaderActions({ zoom, zoomOut, zoomIn, onDownload, current }) {
  return (
    <Box className={styles.headerActions}>
      <Tooltip text="Zoom out" placement="bottom">
        <IconButton type="button" size="small" className={styles.headerIconBtn} onClick={zoomOut} aria-label="Zoom out" disabled={zoom <= 0.5}>
          <ZoomOut24Regular className={styles.headerIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      <Tooltip text="Zoom in" placement="bottom">
        <IconButton type="button" size="small" className={styles.headerIconBtn} onClick={zoomIn} aria-label="Zoom in" disabled={zoom >= 4}>
          <ZoomIn24Regular className={styles.headerIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      <Tooltip text="Download" placement="bottom">
        <IconButton type="button" size="small" className={styles.headerIconBtn} onClick={onDownload} aria-label={`Download ${current?.file?.name || 'image'}`}>
          <ArrowDownload24Regular className={styles.headerIcon} aria-hidden />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
